import { AsyncActions } from '../../standard-actions/';
import { CHANNEL_CARE_LIST_FILTER, CHANNEL_CARE_LOAD_CASES, CHANNEL_CARE_STORE_FILTER } from './action-types';
import { ICasesResponse, ISearchFilter, ISelectedFilters } from '../state/cases';

export interface ILoadCasesAction extends AsyncActions.IAsyncFetchableAction<CHANNEL_CARE_LOAD_CASES> {
}

export interface ILoadCasesSuccessAction extends AsyncActions.IAsyncAction<CHANNEL_CARE_LOAD_CASES> {
    data: ICasesResponse;
    selectedCompanyId: string;
}
export interface ILoadCasesResetAction extends AsyncActions.IAsyncAction<CHANNEL_CARE_LOAD_CASES> {
    data: ICasesResponse;
    selectedCompanyId: string;
}

export interface ILoadCasesFilterSuccessAction extends AsyncActions.IAsyncAction<CHANNEL_CARE_LIST_FILTER> {
    data: ISearchFilter
}

export interface IStoreSFSuccessAction extends AsyncActions.IAsyncAction<CHANNEL_CARE_STORE_FILTER> {
    data: ISelectedFilters
}

export type LoadCasesErrorAction = AsyncActions.IAsyncErrorAction<CHANNEL_CARE_LOAD_CASES>;

export const loadCasesReset = (): ILoadCasesResetAction => ({
    status: AsyncActions.AsyncActionState.NotStarted,
    type: CHANNEL_CARE_LOAD_CASES,
    data: {
        cases: [],
        original_cases: [],
        fetchTime: new Date().getTime(),
    },
    selectedCompanyId: ""
});
export const loadCasesStart = (): ILoadCasesAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: CHANNEL_CARE_LOAD_CASES,
    isFetchable: true
});

export const loadCasesSuccess = (data: ICasesResponse, selectedCompanyId: string): ILoadCasesSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: CHANNEL_CARE_LOAD_CASES,
    data,
    selectedCompanyId
});

export const loadCasesError = (error: string): LoadCasesErrorAction => ({
    status: AsyncActions.AsyncActionState.Failure,
    type: CHANNEL_CARE_LOAD_CASES,
    error
});

export const supportFilterSuccess = (data: ISearchFilter): ILoadCasesFilterSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: CHANNEL_CARE_LIST_FILTER,
    data
});

export const storeSelectedFiltersSuccess = (data: ISelectedFilters): IStoreSFSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: CHANNEL_CARE_STORE_FILTER,
    data
})
